import ExecutionPage from '@/modules/quant/execution/execution-page';
import { requireCapability } from '@/utils/route-guards';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_dashboard/dashboard/quant/execution/',
)({
  beforeLoad: () => requireCapability('quantLab'),
  component: ExecutionPage,
});
